import React from 'react'

interface EyeOffProps {
  size?: number
  color?: string
}

export const EyeOff: React.FC<EyeOffProps> = ({
  size = 24,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C7.12033 21.0002 2.98258 17.8225 1.54337 13.4235C1.24128 12.5001 1.24126 11.5004 1.54334 10.577C2.13064 8.7818 3.16733 7.19002 4.52047 5.93457L2.10077 3.51488C1.71025 3.12436 1.71025 2.49119 2.10077 2.10066C2.4913 1.71014 3.12446 1.71014 3.51499 2.10066L21.8998 20.4854C22.2903 20.8759 22.2903 21.5091 21.8998 21.8996C21.5093 22.2902 20.8761 22.2902 20.4855 21.8997L17.8827 19.2968ZM5.9356 7.3497C5.03982 8.16566 4.3076 9.16182 3.79835 10.2859C3.30627 11.3721 3.30634 12.6285 3.79846 13.7147C5.22236 16.8574 8.38917 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM21.4581 15.6203C21.142 16.1512 20.4159 16.2016 19.9789 15.7647C19.6303 15.416 19.5883 14.8701 19.8319 14.4415C20.1107 13.9508 20.3449 13.4305 20.5288 12.8857C20.7225 12.3117 20.7224 11.6884 20.5287 11.1144C19.3173 7.52562 15.9206 5.00016 12.0003 5.00016C11.369 5.00016 10.7512 5.06565 10.154 5.19052C9.77957 5.26882 9.38493 5.17062 9.11442 4.90011C8.57627 4.36196 8.77121 3.45403 9.51271 3.28261C10.3121 3.09783 11.1448 3.00016 12.0003 3.00016C17.0845 3.00016 21.3632 6.44954 22.6236 11.1358C22.7758 11.7016 22.7758 12.2986 22.6237 12.8644C22.3603 13.8438 21.965 14.7692 21.4581 15.6203ZM11.9192 7.70485C11.843 7.62867 11.8926 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.1078 16.3718 12.1574 16.2957 12.0813L11.9192 7.70485Z"
        fill={color}
      />
    </svg>
  )
}
